export const TEST_ID = 'floatingResourceAddButton';
